/**
 * Consents Zod schemas (m14).
 */

import { z } from 'zod';

export const ConsentTypeSchema = z.enum([
  'TOS',
  'PRIVACY',
  'DPDPA_PROCESSING',
  'WHATSAPP_MARKETING',
  'GEOFENCE_GPS',
]);

export const CaptureConsentInputSchema = z.object({
  consentType: ConsentTypeSchema,
  version: z.string().min(1).max(32),
});

export type ConsentType = z.infer<typeof ConsentTypeSchema>;
export type CaptureConsentInput = z.infer<typeof CaptureConsentInputSchema>;
